import { requireId, storerFetchList, storerRequest } from "../storer/storerRequest";

/* Supplier Management — /api/supplier and /api/supplier/ship-from */

export const getallsupplier = (page, pageSize, filters) =>
    storerFetchList("supplier/fetch-multi-dynamic", page, pageSize, filters);

export const searchSupplierById = (page, pageSize, filters) =>
    storerFetchList("supplier/fetch-multi-details", page, pageSize, filters);

export const addSupplier = (userData) =>
    storerRequest("post", "supplier/create", userData, "Failed to create supplier");

export const onboardSupplier = (body) =>
    storerRequest("post", "supplier/onboardPartner", body, "Failed to onboard supplier");

export const updateSupplier = (userData, id) =>
    storerRequest(
        "put",
        `supplier/update/${requireId(id, "Missing supplier id")}`,
        userData,
        "Failed to update supplier"
    );

export const disableSupplier = (body) =>
    storerRequest("post", "supplier/disablePartner", body, "Failed to disable supplier");

export const fetchShipFroms = (page, pageSize, filters) =>
    storerFetchList("supplier/ship-from/fetch-multi-dynamic", page, pageSize, filters);

export const addShipFrom = (userData) =>
    storerRequest("post", "supplier/ship-from/create", userData, "Failed to create ship from");

export const updateShipFrom = (userData, id) =>
    storerRequest(
        "put",
        `supplier/ship-from/update/${requireId(id, "Missing ship from id")}`,
        userData,
        "Failed to update ship from"
    );

export const deleteShipFrom = (id) =>
    storerRequest(
        "delete",
        `supplier/ship-from/delete/${requireId(id, "Missing ship from id")}`,
        undefined,
        "Failed to delete ship from"
    );
